import FollowHeader from "./follow-header";

export default FollowHeader;